// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Ms_9h066Cn_yrrbAwIxWC","field":"psZwkbNWlJpDBhNBguqeQ","newPriceFields":"_2VZ2P68EdKtVzdyWXbox7P","pricesList":"_3IJAFz_nM3qcWToyaOCx5y"};